import React, { FC } from 'react';

const AssetIdDisplay: FC<any> = ({ asset }): React.ReactElement => {
	return (
		<div className="flex text-gray-500">
			<div className="mr-4">{`Asset ID ${asset.buyerSpecificAssetId || asset.id}`}</div>
			{asset.serialNumber ? (
				<div className="mr-4">{`Serial Number ${asset.serialNumber}`}</div>
			) : null}
		</div>
	);
};

export default AssetIdDisplay;
